<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const paginationContext = usePaginationContext();
const route = useRoute();
const { t } = useI18n();

function buildPageUrl(pageNumber: number) {
  const pageQueryKey = t('Pagination.Query.Page');

  const searchParams = new URLSearchParams(route.query as Record<string, string>);

  if (pageNumber === 1) {
    searchParams.delete(pageQueryKey);
  } else {
    searchParams.set(pageQueryKey, String(pageNumber));
  }

  const query = searchParams.toString();
  return query ? `${route.path}?${query}` : route.path;
}

const activeDisplayPages = computed(() => {
  return paginationContext.displayPages.value.filter((page) => !page.disabled);
});
</script>

<template>
  <ul
    class="sr-only"
    aria-hidden="true"
  >
    <li
      v-for="page in activeDisplayPages"
      :key="`robot-link-${page.key}`"
    >
      <a
        tabindex="-1"
        class="pagination__robot-link"
        :href="buildPageUrl(page.number)"
      >
        {{ page.number }}
      </a>
    </li>
  </ul>
</template>
